import { MODAL_ENTER, MODAL_EXIT } from 'constants/action_names';

export const enterModal = () => ({
  type: MODAL_ENTER,
});

export const exitModal = () => ({
  type: MODAL_EXIT,
});
